var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { importECDHES, importRSAOAEP, importHS256, importAESKW } from './BrowserKeyImportHelper';
import { parseJwk } from '@authing/jose';
var KeyManager = /** @class */ (function () {
    function KeyManager(options, naiveHttpClient, baseClient) {
        var _this = this;
        this.naiveHttpClient = naiveHttpClient;
        this.baseClient = baseClient;
        this.keystore = this.naiveHttpClient.request({
            url: this.baseClient.appHost + "/oidc/.well-known/jwks.json",
            method: 'GET',
        }).then(function (serverJwks) { return __awaiter(_this, void 0, void 0, function () {
            var ks, _i, _a, jwk, _b, _c, aesKWAlg, _d, _e, _f, _g, crypto_1, key, _h, _j, privateKey, importer, _k, _l, crypto_2;
            var _m, _o, _p, _q;
            return __generator(this, function (_r) {
                switch (_r.label) {
                    case 0:
                        ks = [];
                        _i = 0, _a = serverJwks.keys;
                        _r.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        jwk = _a[_i];
                        _c = (_b = ks).push;
                        _m = {
                            alg: [jwk.alg]
                        };
                        return [4 /*yield*/, parseJwk(jwk)];
                    case 2:
                        _c.apply(_b, [(_m.key = _r.sent(),
                                _m)]);
                        _r.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        if (!options.secret) return [3 /*break*/, 8];
                        aesKWAlg = ['A128KW', 'A192KW', 'A256KW'];
                        if (!(typeof window !== 'undefined')) return [3 /*break*/, 7];
                        _e = (_d = ks).push;
                        _o = {
                            alg: ['HS256']
                        };
                        return [4 /*yield*/, importHS256(options.secret)];
                    case 5:
                        _e.apply(_d, [(_o.key = _r.sent(),
                                _o)]);
                        _g = (_f = ks).push;
                        _p = {
                            alg: aesKWAlg
                        };
                        return [4 /*yield*/, importAESKW(options.secret)];
                    case 6:
                        _g.apply(_f, [(_p.key = _r.sent(),
                                _p)]);
                        return [3 /*break*/, 8];
                    case 7:
                        crypto_1 = require('crypto');
                        key = crypto_1.createSecretKey(Buffer.from(options.secret));
                        ks.push({
                            alg: ['HS256'],
                            key: key,
                        });
                        ks.push({
                            alg: aesKWAlg,
                            key: key,
                        });
                        _r.label = 8;
                    case 8:
                        if (!options.privateKeys) return [3 /*break*/, 13];
                        _h = 0, _j = options.privateKeys;
                        _r.label = 9;
                    case 9:
                        if (!(_h < _j.length)) return [3 /*break*/, 13];
                        privateKey = _j[_h];
                        if (!(typeof window !== 'undefined')) return [3 /*break*/, 11];
                        importer = {
                            'RSA-OAEP': importRSAOAEP,
                            'ECDH-ES': importECDHES,
                        };
                        _l = (_k = ks).push;
                        _q = {
                            alg: [privateKey.alg],
                            kid: privateKey.kid
                        };
                        return [4 /*yield*/, importer[privateKey.alg](privateKey.pkcs8Key)];
                    case 10:
                        _l.apply(_k, [(_q.key = _r.sent(),
                                _q)]);
                        return [3 /*break*/, 12];
                    case 11:
                        crypto_2 = require('crypto');
                        ks.push({
                            alg: [privateKey.alg],
                            kid: privateKey.kid,
                            key: crypto_2.createPrivateKey(privateKey.pkcs8Key),
                        });
                        _r.label = 12;
                    case 12:
                        _h++;
                        return [3 /*break*/, 9];
                    case 13: return [2 /*return*/, ks];
                }
            });
        }); }).catch(function (e) {
            console.error('服务器 JWKS 端点请求失败');
            console.error(e);
            return [];
        });
    }
    KeyManager.prototype.getKeyFor = function (condition) {
        return __awaiter(this, void 0, void 0, function () {
            var alg, kid, keystore, _i, keystore_1, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        alg = condition.alg, kid = condition.kid;
                        return [4 /*yield*/, this.keystore];
                    case 1:
                        keystore = _a.sent();
                        for (_i = 0, keystore_1 = keystore; _i < keystore_1.length; _i++) {
                            key = keystore_1[_i];
                            if (kid && key.kid && kid !== key.kid) {
                                continue;
                            }
                            if (alg && !key.alg.includes(alg)) {
                                continue;
                            }
                            return [2 /*return*/, key.key];
                        }
                        throw new Error("No suitable key found for {alg=" + alg + ", kid=" + kid + "}");
                }
            });
        });
    };
    return KeyManager;
}());
export { KeyManager };
//# sourceMappingURL=data:application/json;base64,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